/**
 * This file is where we export the Mantine components that we want to use in our app.
 * If we ever want to wrap a Mantine component in a custom component, add those in
 * another file in this folder.
 */
export {createTheme, MantineProvider} from "@mantine/core";
export {
	Accordion,
	Alert,
	Badge,
	Button,
	Card,
	CardSection,
	Collapse,
	Group,
	Image,
	Loader,
	Menu,
	Modal,
	MultiSelect,
	Select,
	Tabs,
	TextInput,
	Tooltip,
} from "@mantine/core";
export {Carousel} from "@mantine/carousel";
export {DatePickerInput} from "@mantine/dates";
export {AopsThemeProvider} from "./AopsThemeProvider";
